import {
  CollectionRestaurantDetail,
  CollectionRestaurantSummary,
  DeliveryRestaurantDetail,
  DeliveryRestaurantSummary,
} from '../../../weborder/Api';
import * as Data from '../../../weborder/Data';
import * as Store from '../../../weborder/Store';
import { Async } from '../../types/data.types';
import { Campaign, SetCampaignProgress } from './store.types';

const setCollectionSummaries = (
  collectionSummaries: Data.Async<CollectionRestaurantSummary[]>,
): Store.SetCollectionSummaries => ({
  type: 'SET_COLLECTION_SUMMARIES',
  payload: collectionSummaries,
});

const setDeliverySummaries = (
  deliverySummaries: Data.Async<DeliveryRestaurantSummary[]>,
): Store.SetDeliverySummaries => ({
  type: 'SET_DELIVERY_SUMMARIES',
  payload: deliverySummaries,
});

export const setRestaurantCollection = (
  prId: number,
  restaurant: Async<CollectionRestaurantDetail>,
): Store.SetRestaurantCollection => ({
  type: 'SET_RESTAURANT_COLLECTION',
  payload: {
    restaurant,
    prid: prId,
  },
});

export const setRestaurantDelivery = (
  deliveryLocationId: number,
  restaurant: Async<DeliveryRestaurantDetail>,
  vrId: number,
): Store.SetRestaurantDelivery => ({
  type: 'SET_RESTAURANT_DELIVERY',
  payload: {
    dlid: deliveryLocationId,
    restaurant,
    vrid: vrId,
  },
});

export const setCampaignProgress = (
  campaignProgress: Data.Async<Campaign[]> & { storeId: number },
): SetCampaignProgress => ({
  type: 'SET_CAMPAIGN_PROGRESS',
  payload: campaignProgress,
});

export const storeActions = {
  setCollectionSummaries,
  setDeliverySummaries,
};
